import { render, staticRenderFns } from "./ktabslist.vue?vue&type=template&id=1e425ee7"
import script from "./ktabslist.vue?vue&type=script&lang=js"
export * from "./ktabslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports